import axios from '@/axios.js'

export default {
  getAppResorts: async (appUuid) => {
    const response = await axios.editorapi.get(`apps/v3/${appUuid}/resorts`)
    return response.data.object
  },

  getResortSettings: async (resortUuid) => {
    try {
      const response = await axios.editorapi.get(`v4/snowreport/${resortUuid}/settings`)
      return response.data.object
    } catch (error) {
      if (error.response && error.response.status === 404) return null
      throw error
    }
  },

  updateResortSettings: async (resortUuid, payload) => {
    const response = await axios.editorapi.patch(`v4/snowreport/${resortUuid}/settings`, payload)
    return response.data.object
  },

  createResortSettings: async (resortUuid, payload) => {
    const response = await axios.editorapi.post(`v4/snowreport/${resortUuid}/settings`, payload)
    return response.data.object
  },

  getSnowReportZones: async (resortUuid) => {
    try {
      const response = await axios.editorapi.get(`v4/snowreport/zones/${resortUuid}`)
      return response.data.object
    } catch (error) {
      if (error.response && error.response.status === 404) return null
      throw error
    }
  },

  getProviderInfo: async (providerId) => {
    try {
      const response = await axios.editorapi.get(`v4/snowreport-provider/${providerId}`)
      return response.data.object
    } catch (error) {
      if (error.response && error.response.status === 404) return null
      throw error
    }
  },

  forceProviderRefresh: async (providerId, payload) => {
    const response = await axios.editorapi.patch(`v4/snowreport-provider/${providerId}`, payload)
    return response.data.object
  },
}
